<template>
  <div class="checkout-approved">
    <div class="component">
      <div class="installment-title" v-apply-theme>
        Escolha um valor de entrada
      </div>
      <DownPaymentList
        id="down-payment-list"
        v-if="downPaymentOptions"
        :loadingValues="downPaymentValueSkeleton"
        :indexSelected="downPaymentIndexSelected"
        @downPaymentChange="onDownpaymentChange"
        :downPaymentOptions="downPaymentOptions"
      />
    </div>
    <div class="component">
      <div class="installment-title" v-apply-theme>
        Quantidade de parcelas
      </div>
      <InstallmentSelect
        id="installment-select"
        ref="installment-select"
        :indexSelected="installmentIndexSelected"
        v-if="downPaymentSelected"
        @installmentSelect="onInstallmentSelect"
        :installments="dueDateSelected.installmentOptions"
        :loading="installmentValueSkeleton"
      />
    </div>
    <div class="component">
      <div class="installment-title" v-apply-theme>
        Vencimento da primeira parcela
      </div>
      <PaymentDateOptions
        :dateOptions="dateOptions"
        @dueDateSelect="onDueDateSelect"
      />
    </div>
    <div class="component">
      <CheckoutSummaryShort
        v-if="downPaymentSelected"
        :loading="summarySkeleton"
        :totalAmount="installmentSelected && installmentSelected.totalAmount"
        :interestRatePM="installmentSelected && installmentSelected.interestRatePM"
        :cetPA="installmentSelected && installmentSelected.cetPA"
        :oneLineFooter="true"
      />
    </div>

    <Button
      class="primary checkout-confirm-button"
      :disabled="summarySkeleton || (typeof installmentIndexSelected !== 'number')"
      @click="handleFinishTransaction"
      >
      Finalizar compra
    </Button>

    <div class="return-button" :class="{ mobile: isMobile }">
      <Button class="link button-link" :class="{ mobile: isMobile }" :href="checkoutUrl">
        Cancelar e voltar para loja
      </Button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import DownPaymentList from '@/components/common/DownPaymentList.vue';
import InstallmentSelect from '@/components/common/InstallmentSelect.vue';
import Button from '@/components/ui/AppButton.vue';
import { ApplyTheme } from '@/directives/applyTheme';
import isMobile from '@/lib/isMobile';
import CheckoutSummaryShort from '../../../components/checkout/CheckoutSummaryShort.vue';
import PaymentDateOptions from '../../../components/checkout/PaymentDateOptions.vue';

export default {
  name: 'checkout-approved-grace',
  directives: {
    ApplyTheme,
  },
  data: () => ({
    isMobile: false,
  }),
  computed: {
    ...mapState('checkoutFallback', [
      'downPaymentIndexSelected',
      'dueDateIndexSelected',
      'installmentIndexSelected',
      'downPaymentOptions',
      'summarySkeleton',
      'downPaymentValueSkeleton',
      'installmentValueSkeleton',
      'config',
      'hasPreCondition',
      'checkoutUrl',
    ]),
    ...mapGetters('checkoutFallback', [
      'downPaymentSelected',
      'installmentSelected',
      'dueDateSelected',
      'ccbUrl',
      'dateOptions',
    ]),
    confirmText() {
      return (this.config && this.config.confirmText) || 'Pagar parcelado no boleto';
    },
    confirmButton() {
      return (this.config && this.config.confirmButtom) || false;
    },
    showCCBText() {
      return (this.config && this.config.showCCBText) || false;
    },
  },
  methods: {
    ...mapActions('checkoutFallback', [
      'setInstallmentIndex',
      'resetLoading',
      'setDownPaymentIndex',
      'pay',
      'emitEvent',
      'setDueDateIndex',
    ]),
    onDownpaymentChange(index) {
      this.setDownPaymentIndex(index);
    },
    onInstallmentSelect(index) {
      this.setInstallmentIndex(index);
    },
    onDueDateSelect(index) {
      this.setDueDateIndex(index);
    },
    async handleFinishTransaction() {
      await this.pay();
    },
  },
  components: {
    DownPaymentList,
    InstallmentSelect,
    CheckoutSummaryShort,
    PaymentDateOptions,
    Button,
  },
  mounted() {
    this.isMobile = isMobile();
    this.resetLoading();
    if (this.hasPreCondition) {
      this.emitEvent({
        type: 'preapproved',
      });
    } else {
      this.emitEvent({
        type: 'approved',
      });
    }
  },
};
</script>

<style lang="scss" scoped>#checkout-confirm-button {
  margin-top: 20px;
  @media (max-width: $md) {
    width: 100%;
    height: 48px;
  }
}

.component:not(:last-of-type) {
  margin-bottom: 16px;
}

.installment-title, .down-payment-list-title {
  @extend .body-bold;
  @extend .gray-700;
  margin-bottom: 8px;
  &--vivo {
    font-weight: normal;
  }
}

.ccb-text {
  @extend .x-small-regular;
  margin: 12px 0 8px;
  text-align: center;

  a {
    @extend .primary;
    text-decoration: none;
  }
}
</style>
